export const suisseBoldMetrics = {
  familyName: "SuisseIntl-Bold",
  fullName: "SuisseIntl-Bold",
  postscriptName: "SuisseIntl-Bold",
  capHeight: 706,
  ascent: 997,
  descent: 370,
  lineGap: 0,
  unitsPerEm: 1000,
  xHeight: 538,
  xWidthAvg: 496,
  subsets: {
    latin: {
      xWidthAvg: 496,
    },
    thai: {
      xWidthAvg: 500,
    },
  },
};
